import { ParametroCondominioDTO } from "./ParametroCondominioDTO";

export type CondominioContextoDTO = {
  id: number | null;
  uuid: string | null;
  nomeCondominio: string | null;
  uuidLogo: string | null;
  cnpj: string | null;
  razaoSocial: string | null;
  parametroCondominio: ParametroCondominioDTO | null;
};

export const CONDOMINIO_CONTEXTO_VAZIO = {
  id: null,
  uuid: null,
  nomeCondominio: null,
  uuidLogo: null,
  parametroCondominio: null,
  cnpj: null,
  razaoSocial: null,
};
